'use client'

import { useDeskMenu } from '@/deskUiSkeletons/Menu/menuModel'

export function ForumParentTrail() {
  const { parents } = useDeskMenu()
  if (!parents.canSee) return null

  const links = parents.links
    .filter(parent => parent.msgType === 'forum')
    .reverse()
  if (links.length < 1) return null

  return (
    <nav
      className="md-forum-parent-trail mb-4 border border-[#006699] bg-[#eef3f8] px-2 py-1 font-[Verdana,Arial,Helvetica,sans-serif] text-[10px] text-[#006699]"
      aria-label="Forum ancestry"
    >
      <ol className="flex list-none flex-wrap items-center gap-x-2 gap-y-1 p-0">
        {links.map((parent, index) => (
          <li key={`${parent.number}:${parent.codeKey}`} className="flex min-w-0 items-center gap-2">
            {index > 0 ? <span aria-hidden="true">›</span> : null}
            <a className="max-w-[32rem] truncate font-bold underline" href={`/${parent.codeKey}`}>
              {parent.subject || parent.label}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  )
}
